import axios from 'axios'
import {
  Message,
  Loading
} from 'element-ui'

import router from '@/router'
import store from '@/store';


let loadingInstance = null //这里是loading
//使用create方法创建axios实例
const Service = axios.create({
  timeout: 1000 * 60 * 10, // 请求超时时间
  method: 'POST',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 环境的切换
if (process.env.NODE_ENV == 'development') {
  Service.defaults.baseURL = '/api';
} else if (process.env.NODE_ENV == 'debug') {
  Service.defaults.baseURL = 'https://www.ceshi.com';
} else if (process.env.NODE_ENV == 'production') {
  Service.defaults.baseURL = '/api';
};

// 请求拦截器
Service.interceptors.request.use(
  config => {
    // loadingInstance = Loading.service({
    //   lock: true,
    //   text: 'loading...'
    // })
    
    // 每次发送请求之前判断vuex中是否存在token        
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
    // const token = store.state.token;
    // token && (config.headers.Authorization = token);
    return config;
  },
  error => {
    console.log(error)
    return Promise.error(error);
  })


// 响应拦截器
Service.interceptors.response.use(
  response => {
    //loadingInstance.close()
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
    // 否则的话抛出错误
    let userInfo = window.sessionStorage.getItem("binyi_cms_loginInfo")
    if(userInfo) {
      let userId = JSON.parse(userInfo).id;
      let storageId = window.localStorage.getItem('zgjs_login_id');
      if(userId != storageId) {
        router.push({
          path: "/userlogin"
        });
        return Promise.reject({message:"同一浏览器只能登录一个有效帐号，您的登录已失效"});
      }
    }
    
    if (response.status === 200) {
      if(response.config.url == "/bygStatistics/export") {
        return Promise.resolve(response);
      }
      // 用户未登录
      switch (response.data.status) {
        case 1000:
          return Promise.resolve(response.data);
          // 1008 重复请求
        case 1001:
          response.data.message = "请求失败，请刷新后再次尝试";
          return Promise.reject(response.data);
        case 1002:
          response.data.message = "请求参数错误";
          return Promise.reject(response.data);
        case 1005:
          response.data.message = "权限不足";
          return Promise.reject(response.data);
        case 1008:
          response.data.message = "您点的太快了，请稍后再试";
          return Promise.reject(response.data);
        case 1006:
          window.sessionStorage.clear();
          router.push({
            path: "/userlogin"
          });
          Message.error("您的登录已失效");
          break;
        case 1027:
          window.sessionStorage.clear();
          router.push({
            path: "/userlogin"
          });
          Message.error("您的登录已失效");
          break;
        default:
          console.log(response)
          return Promise.reject(response.data);
      }
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    try {
      if (error.response.status) {
        return Promise.reject(error.response);
      }
    } catch (error) {
      Message.error('系统异常,请检查网络');
      console.log(error)
    }
  })

export default Service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js